import React from 'react';
import { Combobox as BaseCombobox } from '@base-ui/react/combobox';
import { XIcons } from '../primitives.jsx';

const optionLabel = (option) => option?.label || option?.value || '';

export function SearchableSelect({
  value,
  onChange,
  options = [],
  label,
  placeholder = '搜索…',
  emptyLabel = '没有匹配项',
  disabled = false,
  renderOption,
  getSearchText,
}) {
  const selectedOption = React.useMemo(
    () => options.find((option) => option.value === value) || null,
    [options, value],
  );
  const isDisabled = disabled || options.length === 0;

  return (
    <BaseCombobox.Root
      items={options}
      value={selectedOption}
      onValueChange={(option) => onChange?.(option?.value || '')}
      itemToStringLabel={optionLabel}
      itemToStringValue={(option) => option?.value || ''}
      isItemEqualToValue={(option, selected) =>
        option?.value === selected?.value
      }
      filter={(option, query) => {
        const haystack = getSearchText
          ? getSearchText(option)
          : `${optionLabel(option)} ${option?.value || ''}`;
        return haystack.toLocaleLowerCase().includes(query.toLocaleLowerCase());
      }}
      autoHighlight="always"
      disabled={isDisabled}
    >
      <BaseCombobox.InputGroup className="searchable-select-input-group">
        <XIcons.IconSearch
          size={14}
          aria-hidden="true"
          className="searchable-select-search-icon"
        />
        <BaseCombobox.Input
          className="searchable-select-input"
          aria-label={label}
          placeholder={placeholder}
          disabled={isDisabled}
        />
        <BaseCombobox.Trigger
          className="searchable-select-trigger"
          aria-label={`打开${label || '选项'}列表`}
          disabled={isDisabled}
        >
          <XIcons.IconChevronDown size={13} aria-hidden="true" />
        </BaseCombobox.Trigger>
      </BaseCombobox.InputGroup>

      <BaseCombobox.Portal>
        <BaseCombobox.Positioner
          className="searchable-select-positioner"
          sideOffset={4}
          align="start"
        >
          <BaseCombobox.Popup className="searchable-select-popup">
            <BaseCombobox.Empty className="searchable-select-empty">
              {emptyLabel}
            </BaseCombobox.Empty>
            <BaseCombobox.List className="searchable-select-list">
              {(option, index) => (
                <BaseCombobox.Item
                  key={option.value}
                  value={option}
                  index={index}
                  className="searchable-select-item"
                >
                  <BaseCombobox.ItemIndicator
                    className="searchable-select-indicator"
                    keepMounted
                  >
                    <XIcons.IconCheck size={13} aria-hidden="true" />
                  </BaseCombobox.ItemIndicator>
                  <span className="searchable-select-item-content">
                    {renderOption ? renderOption(option) : optionLabel(option)}
                  </span>
                </BaseCombobox.Item>
              )}
            </BaseCombobox.List>
          </BaseCombobox.Popup>
        </BaseCombobox.Positioner>
      </BaseCombobox.Portal>
    </BaseCombobox.Root>
  );
}
